import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Eye, MoreVertical, CreditCard } from "lucide-react";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import React, { Dispatch, SetStateAction } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useDispatch } from "react-redux";
import { setInvoice } from "@/redux/invoiceSlice";
import { InvoiceStatus } from "@/types/enums";

import { useNavigate } from "react-router-dom";
import { InvoiceDetails } from "@/types/invoice";

export function DataTableRowActions({
  data,
  access,
  payAccess,
  openLinkedMembers,
  setSelectedInvoice,
}: {
  data: InvoiceDetails;
  access: string;
  payAccess: string;
  openLinkedMembers: Dispatch<SetStateAction<boolean>>;
  setSelectedInvoice: Dispatch<SetStateAction<InvoiceDetails | undefined>>;
}) {
  const { toast } = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePay = () => {
    dispatch(setInvoice(data));
    setTimeout(() => {
      navigate('/counter-selection');
    }, 500);
  };

  return (
    <>
      <Dialog>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
            >
              <MoreVertical className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-fit">
            <DialogTrigger asChild>
              <DropdownMenuItem
                onClick={() => {
                  openLinkedMembers(true);
                  setSelectedInvoice(data);
                }}
                className="text-nowrap"
              >
                <Eye className="mr-2 h-4 w-4" />
                View Linked Members
              </DropdownMenuItem>
            </DialogTrigger>
            
            {data.status === InvoiceStatus.Pending && payAccess !== "no_access" && (
              <DropdownMenuItem
                className="text-nowrap"
                onClick={(e) => {
                  e.stopPropagation();
                  handlePay();
                }}
              >
                <CreditCard className="mr-2 h-4 w-4" />
                Pay
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </Dialog>
    </>
  );
}
